import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { Bounce } from 'react-awesome-reveal';
import useSound from 'use-sound';
import dingSound from '../../../assets/audio/ding.mp3'; // your sound file
import './ReadingCelebration.css'; // 👈 import the CSS below
import { getDocument } from '../../../firebase-functions/database';
import { toast } from 'react-toastify';

// import

export const ReadingCelebration = ({ name, book, theme }) => {
  const [visible, setVisible] = useState(true);
  const [play] = useSound(dingSound, { volume: 0.8 });
  const [announcementItem, setAnnouncementItem] = useState();

  useEffect(() => {
    play();
    const timer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(timer);
  }, [play]);

  useEffect(() => {
    getDocument('utils', 'readingAnnouncements').then((res) => {
      if (!res.success) {
        toast.error('Something went wrong!');
        return;
      }

      setAnnouncementItem(res.data.items.find((a) => a.name === theme));
      const tempItem = res.data.items.find((a) => a.name === theme);

      const soundEffect = new Audio(tempItem.audioUrl);

      // Play the sound
      soundEffect.play().catch((error) => {
        // Handle potential errors, such as a user-gesture requirement
        // in some browsers (especially for mobile devices).
        console.error('Error playing sound effect:', error);
      });
    });
  }, [theme]);

  if (!visible) return null;

  return (
    <>
      <div className='celebration-container'>
        <Confetti numberOfPieces={300} recycle={false} />
        {announcementItem && (
          <img
            src={announcementItem.gifUrl}
            style={{
              position: 'absolute',
              top: '10vw',
              left: '40vw',
              width: '20vw',
              height: '20vw',
              zIndex: 1000,
            }}
          />
        )}

        <Bounce>
          <div className='reading-celebration-banner'>
            🎉 {name} just finished reading <em>{book}</em>! 📚
          </div>
        </Bounce>
      </div>
    </>
  );
};
